
import React,{useState, useEffect, useRef} from "react";
import { getData, postData } from "../../../../ApiServices/ApiService";
import {ORG_GET_DOCUMENTS_LIST_RACK} from '../../../../ApiServices/BaseURL';
import { useTheme } from "../../../../GlobalContext/GlobalContext";

const DocumentRackController = ( refreshDashboard, setRefreshDashboard )=>{
    const [kycListLoading, setKycListLoading] = useState(false);
    const [kycListError, setKYCListError] = useState('');
    const [kycDocumentList, setKycDocumentList] = useState([]);
    const { setIsLoginPopup } = useTheme();
    const [hasMoreServerData, setHasMoreServerData] = useState(true);
    const [offset, setOffset] = useState(0);
    const [isFilterData,setIsFilterData] = useState (false)
    useEffect(()=>{
        fetchDocumentsList(0)
    },[])

    useEffect(() => {
      if (refreshDashboard) {
          fetchKYCDocumentsRefresh();
          setRefreshDashboard(false);
      }
  }, [refreshDashboard]);

     const fetchDocumentsList = async (currentOffset = 0) => {
    try {
      setKycListLoading(true);
      setIsFilterData(false);
      setKYCListError('');
      if(currentOffset === 0){
        setKycDocumentList([])
      }
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

      const response = await getData(`${ORG_GET_DOCUMENTS_LIST_RACK}?emp_id_auth=${storedUserInfo?.emp_id}&offset=${currentOffset}`);
      const responseData = await response.json();

      if (response?.status === 200 && responseData?.statusCode === 200) {
        if (responseData?.message.toLowerCase() === 'success') {
          const newDocs = responseData?.dataJ || [];
          setKycDocumentList(prev => [...prev, ...newDocs]);
          // limit.current = responseData?.new_offset || 50;
          setOffset(responseData?.new_offset);  // next offset
          setHasMoreServerData(!responseData?.is_data_end);
        } else {
          setKYCListError(responseData?.info || 'No Doc List Available');
          setHasMoreServerData(false);
        }
      } else if ([400, 401, 403].includes(response?.status)) {
        setKYCListError('Unauthorized access. Your session may have expired. Please log in again.');
        setIsLoginPopup(true);
        setHasMoreServerData(false);
      } else {
        setKYCListError('Unexpected error occurred. Please try again later.');
        setHasMoreServerData(false);
      }
    } catch (error) {
      setKYCListError('Failed to fetch data. Please check your network connection.');
      setHasMoreServerData(false);
    } finally {
      setKycListLoading(false);
    }
  };

      const fetchKYCDocumentsRefresh =(offset)=>{
        if (hasMoreServerData && !kycListLoading) {
      fetchDocumentsList(offset ? offset :0);
    }
      }

      return{
        fetchKYCDocumentsRefresh,
        kycDocumentList,
        kycListError,
        kycListLoading,
        setKycDocumentList,
        setKYCListError,
        setKycListLoading,
        hasMoreServerData,offset,isFilterData,setIsFilterData
      }

}

export default DocumentRackController